module.exports = __webpack_public_path__ + "img/key2.f6e94eaf.png";